import { render, staticRenderFns } from "./TagFormBody.vue?vue&type=template&id=464c39b3&scoped=true"
import script from "./TagFormBody.vue?vue&type=script&lang=js"
export * from "./TagFormBody.vue?vue&type=script&lang=js"
import style0 from "./TagFormBody.vue?vue&type=style&index=0&id=464c39b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464c39b3",
  null
  
)

export default component.exports